<div class="modal-header" translate>Render sequence</div>
<form class="modal-body" #form="ngForm">
  <div class="form-line">
    <div class="header">
      <div class="title" translate>Name</div>
    </div>
    <input
      class="form-control"
      type="text"
      [(ngModel)]="name"
      name="name"
      required
      maxlength="250"
    />
  </div>
  <div class="form-line">
    <div class="header">
      <div class="title" translate>Preset</div>
    </div>
    <div class="input-group">
      <select class="form-control" [(ngModel)]="preset" name="preset" required>
        @for (p of builtinExportPresets; track p) {
          <option [ngValue]="p">{{ p.name }}</option>
        }
        @for (p of customPresets; track p) {
          <option [ngValue]="p">{{ p.name }}</option>
        }
      </select>
      <div class="input-group-append">
        <button class="btn btn-outline-secondary" (click)="pickPresetFile()">
          <i class="far fa-folder-open"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="form-line">
    <div class="header">
      <div class="title" translate>Scope</div>
      <div class="description" translate>The part of the sequence to be rendered</div>
    </div>
    <select class="form-control" [(ngModel)]="scope" name="scope">
      <option [ngValue]="SequenceRenderScope.WorkArea" translate>Work area</option>
      <option [ngValue]="SequenceRenderScope.InOut" translate>In to out</option>
      <option [ngValue]="SequenceRenderScope.Entire" translate>All</option>
    </select>
  </div>
</form>
<div class="modal-footer">
  <button class="btn btn-outline-primary" [clickBlocking]="render" [disabled]="!form.form.valid">
    <i class="far fa-play"></i>
    <span translate>Render</span>
  </button>
  <button class="btn btn-outline-secondary" (click)="cancel()" translate>Cancel</button>
</div>
